module.exports = __webpack_public_path__ + "media/images/ShopViewTemplate-4b04b330e9c415fe4fde5cd8cc2f04ad.png";